import "./Spinner.scss";

export const Spinner = () => (
  <div className="spinner-container">
    <div className="loading-spinner"></div>
  </div>
);
